import placeHolderImage from '../assets/images/product.jpg';

import LogoMain from '../assets/logoBlack.jpg';
import LoginImg from '../assets/images/login.webp';
export { LogoMain, LoginImg };

const baseUrl = process.env.REACT_APP_BASE_URL;

export function getMainImageUrl(images) {
  const mainImg = images ?? placeHolderImage;

  return getFileUrl(mainImg) ?? placeHolderImage;
}

export function formatToINR(amount) {
  if (isNaN(amount)) {
    return amount;
  }
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(amount);
}

export function generateTitle(product) {
  const brandName = product?.name?.trim() || "";
  const cleanPart = (part) => {
    if (!part || !part.trim()) return null;

    const regex = new RegExp(`\\b${brandName}\\b`, "i");
    return part.replace(regex, "").trim();
  };

  const parts = [
    product?.category?.name,
    brandName,
    cleanPart(product?.name),
    cleanPart(product?.name),
  ];

  const validParts = parts.filter((part) => part && part !== "");

  return validParts.join(" ");
}

export const getAlertStyles = (type) => {
  switch (type) {
    case "success":
      return {
        background: "bg-green-50",
        text: "text-primaryDark",
        border: "border-primaryDark",
      };
    case "error":
      return {
        background: "bg-red-50",
        text: "text-red-800",
        border: "border-red-400",
      };
    case "warning":
      return {
        background: "bg-yellow-50",
        text: "text-yellow-800",
        border: "border-yellow-400",
      };
    case "info":
      return {
        background: "bg-blue-50",
        text: "text-blue-800",
        border: "border-blue-400",
      };
    default:
      return {
        background: "bg-gray-50",
        text: "text-gray-800",
        border: "border-gray-400",
      };
  }
};

export function formatDate(timestamp) {
  const date = new Date(timestamp);
  const options = {
    day: "numeric",
    month: "short",
    year: "numeric",
  };
  return date.toLocaleDateString("en-GB", options);
}

export function formatDateTime(timestamp) {
  const date = new Date(timestamp);
  const dateOptions = {
    day: "numeric",
    month: "short",
    year: "numeric",
  };
  const timeOptions = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const formattedDate = date.toLocaleDateString("en-GB", dateOptions);
  const formattedTime = date.toLocaleTimeString("en-GB", timeOptions);

  return `${formattedDate} ${formattedTime}`;
}

export function formatDateUs(insuranceValidDate) {
  const date = new Date(insuranceValidDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}

export function getFileUrl(path) {
  if (path) {
    return baseUrl + "public/" + path;
  }else{
    return LogoMain;
  }
}

export function formatValidationError(errorResponse) {
  let formattedErrors = {};

  if (errorResponse.detail && Array.isArray(errorResponse.detail)) {
    errorResponse.detail.forEach((error) => {
      let field = error.loc[1];
      if (!formattedErrors[field]) {
        formattedErrors[field] = [];
      }
      formattedErrors[field].push(error.msg);
    });
  }

  return {
    response: false,
    msg: "Data validation Failed!",
    errors: formattedErrors,
  };
}

export function removeEmptyValues(data) {
  return Object.fromEntries(
    Object.entries(data).filter(([_, value]) => value !== "" && value !== null)
  );
}

export function formatDateWithTime(date) {
  return new Date(date).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export function strToSlug(str) {
  return str
    ?.toLowerCase()
    .trim()
    .replace(/[\s\W-]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
export function slugToStr(slug) {
  return slug
    ?.replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
export function timeAgo(timestamp) {
  const currentTime = new Date();
  const time = new Date(timestamp);

  if (isNaN(time.getTime())) {
    return "Invalid date";
  }

  const seconds = Math.floor((currentTime - time) / 1000);

  let interval = Math.floor(seconds / 31536000);
  if (interval > 1) {
    return interval + " years ago";
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return interval + " months ago";
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return interval + " days ago";
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return interval + " hours ago";
  }
  interval = Math.floor(seconds / 60);
  if (interval > 1) {
    return interval + " minutes ago";
  }
  return Math.floor(seconds) + " seconds ago";
}
export function numberToWords(num) {
  if (num === 0) return "Zero Rupees Only";

  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  function twoDigits(n) {
    if (n === 0) return "";
    if (n < 20) return a[n];
    return b[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + a[n % 10] : "");
  }

  function threeDigits(n) {
    let str = "";
    if (n >= 100) {
      str += a[Math.floor(n / 100)] + " Hundred";
      if (n % 100 !== 0) str += " and ";
    }
    str += twoDigits(n % 100);
    return str;
  }

  if (num.toString().length > 9) return "Overflow";

  const padded = num.toString().padStart(9, "0");
  const crore = parseInt(padded.slice(0, 2), 10);
  const lakh = parseInt(padded.slice(2, 4), 10);
  const thousand = parseInt(padded.slice(4, 6), 10);
  const rest = parseInt(padded.slice(6), 10);

  let result = "";
  if (crore) result += twoDigits(crore) + " Crore ";
  if (lakh) result += twoDigits(lakh) + " Lakh ";
  if (thousand) result += twoDigits(thousand) + " Thousand ";
  if (rest) result += threeDigits(rest) + " ";

  return result.trim();
}

export function accessoriesCategories() {
  return [
    "Tempered Glass",
    "Charging Cable",
    "Charging Adapter",
    "Earphone",
    "Back Cover",
  ];
}


export function formatTimeWithAmPm(time) {
  if (!time) return "";
  const [hour, minute] = time.split(":");
  let h = parseInt(hour, 10);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h.toString().padStart(2, "0")}:${minute} ${ampm}`;
}


export const generateUserId = (name, corpName) => {
  if (!name || !corpName) return "";
  const userPart = name.trim().replace(/\s+/g, "").substring(0, 4).toUpperCase();
  const corpPart = corpName.trim().replace(/\s+/g, "").slice(-4).toUpperCase();

  return `${userPart}${corpPart}`;
};
